<template>

<div class="selectp">
	<div class="select_bg"></div>
	<div class="select_p1">
		<el-input  placeholder="请输入姓名" prefix-icon="el-icon-edit" v-model="username" class="select_input"/><span style="width:20px"></span>
		<!-- <el-select v-model="type" placeholder="请选择"  style="width:100%; margin-top: 10px;">
			<el-option label="论文展" value="论文">论文展</el-option>
			<el-option label="成果展" value="成果">成果展</el-option>
		</el-select> -->
		<el-button type="primary" icon="el-icon-search" style="width:100%;margin-top: 10px;" class="select_button" @click="select">查询</el-button>
	</div><br>
	<div class="block" v-show="!show"></div>
	<div v-show="show">
		<div class="prize"  v-for="item in userinfo">
			<p></p>
			<div>作者姓名:<span  class="prize_s"></span>{{item.name}}</div>
			<div>所获奖项:<span class="prize_s"></span>{{item.prize}}</div>
			<div>获奖作品:<span class="prize_s"></span>{{item.worksname}}</div>
			<div>
				作品类型:
				<span class="prize_s" v-if="item.type == '成果'">{{item.workstype}}(课改成果展评)</span>
				<span class="prize_s" v-else>{{item.workstype}}</span>
			</div>
			<div>所在学校:<span class="prize_s"></span>{{item.school}}</div>
			
			<div>
				届数:
				<span class="prize_s" v-if="item.jieshu == 1">第一届</span>
				<span class="prize_s" v-if="item.jieshu == 2">第二届</span>
				<span class="prize_s" v-if="item.jieshu == 3">第三届</span>
				<span class="prize_s" v-if="item.jieshu == 4">第四届</span>
				<span class="prize_s" v-if="item.jieshu == 5">第五届</span>
			</div>
		
			<p></p>
		</div>
	</div>
	  <div class="banner-aaa"></div>
</div>


</template>

<script>
import "@/assets/base.css";
import "@/assets/xspx.css";

 export default {
    
    data() {
      return {
		  userinfo:[],
		  nickname : null,
		  username:null,
		  show:false,
		  type:null,
      }
    },

    methods: {
		 _isMobile(){
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },

	  select:function(){
		  var that = this;
		  var name = this.username 
		  var type = this.type 
		  if(name==null || name==""){
			  alert("请输入姓名")
		  } else {
			 //上线前记得吧vue.config中的target修改了 还有后台的WebMvcConfig修改了
			   that.$axios.get("https://xspxserver.zhyww.cn/xspxPrize/getPrize",//http://xspxserver.zhyww.cn/xspxPrize/getPrize   http://localhost:8080/xspxPrize/getPrize
                {params:{
				name:name,
				type:type,
                }})
              .then(function (response) {
				  console.log( response.data.xspxPrizes)
				  var state = response.data.state
				  if(state == "1"){
  					that.userinfo = response.data.xspxPrizes
				    that.show = true
				  } else {
					  alert("没有查到获奖信息")
				  }
				  
				
              }).catch(function (reason) {
                  alert("error");
              });
			
		  }
	  }
	},
	
	 mounted: function() {
    if (this._isMobile()) {
      
    
      this.$router.replace('/hjcxPhone');
    }else {
      //alert('pc端');
      //this.$router.replace('/hjcx');
    }
  },
    
  }
</script>
<style>
 .selectp{
   	width: 100%;
 }
 .block{
  width:100px;
  height: 100px;
  background:url('../assets/images/empty1.png');
  background-size:100% 100%;
  margin: 100px auto 0 auto;
 }
 .select_bg{
  height: 200px;
  background:url('../assets/images/qishi123.png');
  background-size:100% 100%;
	
}
 .select_p1{
	 
	 text-align: center;
	
	 width:95%;
	 margin: 20px auto 0 auto;
 }
 .lip_top{
	
 }
 .prize{
	 margin-top: 30px;
	 margin-left: 2.5%;
	 width: 95%;
	 border-radius: 5px;
	 background-color: white;
	 
 }
 .prize div{
	 margin-left: 3%;
	 font-size: 14px;
	 margin-top: 5px;
 }
  .prize p{
	 height: 5px;
 }
 .prize_s{
	 margin-left: 3%;
 }
   .banner-aaa{
    height: 30px;
   
}
</style>